// extracted by mini-css-extract-plugin
module.exports = {"section":"FeaturedImages_section__Jjbdg","image":"FeaturedImages_image__Yz1mz"};